import React, { createContext, useState, useEffect, ReactNode } from 'react';

interface ThemeColors {
  bgColor: string;
  bgSecondaryColor: string;
  textColor: string;
  inputBgColor: string;
  inputTextColor: string;
  hoverColor: string;
  arrowBg: string;
  cardBg: string;
  primaryColor: string;
  primaryText: string;
  secondaryColor: string;
  borderColor: string;
}


interface ThemeContextType {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  colors: ThemeColors;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    const storedValue = localStorage.getItem('isDarkMode');
    return storedValue ? JSON.parse(storedValue) : false;
  });

  const toggleDarkMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem('isDarkMode', JSON.stringify(newMode));
  };
  const colors: ThemeColors = {
    bgColor: isDarkMode ? "bg-black" : "bg-white",
    bgSecondaryColor: isDarkMode ? "bg-neutral-950" : "bg-gray-50",
    textColor: isDarkMode ? "text-white" : "text-black",
    inputBgColor: isDarkMode ? "bg-zinc-900" : "bg-gray-100",
    inputTextColor: isDarkMode ? "text-white" : "text-black",
    hoverColor: isDarkMode ? "hover:bg-green-900" : "hover:bg-green-100",
    arrowBg: isDarkMode ? "bg-zinc-800" : "bg-zinc-200",
    cardBg: isDarkMode ? "bg-zinc-950" : "bg-white",
    primaryColor: isDarkMode ? "bg-green-500" : "bg-green-600",
    primaryText: isDarkMode ? "text-green-400" : "text-green-700",
    secondaryColor: isDarkMode ? "bg-green-800" : "bg-green-100",
    borderColor: isDarkMode ? "border-zinc-800" : "border-zinc-300",
  };


  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleDarkMode, colors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeProvider, ThemeContext };
